import { Breadcrumb, Button, Tabs, Tooltip } from "antd";
import "antd/dist/antd.min.css";
import React, { useCallback, useState } from "react";
import "../../styles/Main.scss";

import TabPane from "antd/lib/tabs/TabPane";
import { InfoCircleOutlined, LeftOutlined } from "@ant-design/icons";
import { ReactComponent as Back } from "../../image/Back.svg";
import { Link, useNavigate } from "react-router-dom";
import AiDocIntakePdf from "./mainAiDocuments/AiDocIntakePdf";
import DraftGoodsReceipt from "./mainAiDocuments/DraftGoodsReceipt";
import GoodsRecieptGateList from "./mainAiDocuments/GoodsRecieptGateList";
import InboundMaterialShipments from "./mainAiDocuments/SiteReceipt";
import AcceptanceDist from "./mainAiDocuments/AcceptanceDist";
import StoreConfirmPhysicalReceipt from "./mainAiDocuments/StoreConfirmPhysicalReceipt";
import { t } from "i18next";

const TAB_KEYS = {
  INTAKE: "1",
  DRAFTS: "2",
  GATE_LIST_CHALLAN: "3",
  GATE_LIST_INVOICE: "4",
  SITE_RECEIPT: "5",
};

const TabwiseDocument = () => {
  const [activeKey, setActiveKey] = useState(TAB_KEYS.INTAKE);
  const [editDraftId, setEditDraftId] = useState(null);
  const [acceptanceView, setAcceptanceView] = useState(null);
  const [physicalReceiptDocumentId, setPhysicalReceiptDocumentId] =
    useState(null);
  const [physicalReceiptSiteId, setPhysicalReceiptSiteId] = useState(null);
  const [physicalReceiptIsViewMode, setPhysicalReceiptIsViewMode] = useState(false);
  const [refreshDrafts, setRefreshDrafts] = useState(0);
  const [refreshGateListInvoice, setRefreshGateListInvoice] = useState(0);
  const [refreshGateListChallan, setRefreshGateListChallan] = useState(0);
  const [refreshSiteReceipt, setRefreshSiteReceipt] = useState(0);
  const navigate = useNavigate();
  const goToTab = useCallback((key, options = {}) => {
    setActiveKey(key);
    if (options.editDraftId !== undefined) setEditDraftId(options.editDraftId);
    if (options.clearEditDraft) setEditDraftId(null);
    if (options.clearAcceptance) setAcceptanceView(null);
    if (options.clearPhysicalReceipt) {
      setPhysicalReceiptDocumentId(null);
      setPhysicalReceiptSiteId(null);
      setPhysicalReceiptIsViewMode(false);
    }
    if (key === TAB_KEYS.DRAFTS) setRefreshDrafts((c) => c + 1);
    if (key === TAB_KEYS.GATE_LIST_INVOICE) setRefreshGateListInvoice((c) => c + 1);
    if (key === TAB_KEYS.GATE_LIST_CHALLAN) setRefreshGateListChallan((c) => c + 1);
    if (key === TAB_KEYS.SITE_RECEIPT) setRefreshSiteReceipt((c) => c + 1);
  }, []);

  const handleTabChange = (key) => {
    setAcceptanceView(null);
    setPhysicalReceiptDocumentId(null);
    setPhysicalReceiptSiteId(null);
    setPhysicalReceiptIsViewMode(false);
    setActiveKey(key);
    if (key === TAB_KEYS.DRAFTS) setRefreshDrafts((c) => c + 1);
    if (key === TAB_KEYS.GATE_LIST_INVOICE) setRefreshGateListInvoice((c) => c + 1);
    if (key === TAB_KEYS.GATE_LIST_CHALLAN) setRefreshGateListChallan((c) => c + 1);
    if (key === TAB_KEYS.SITE_RECEIPT) setRefreshSiteReceipt((c) => c + 1);
  };

  return (
    <>
      <section className="grid-sec FormSection Container">
        <div className="FormBody" style={{ padding: "0" }}>
          <div className="stepscontentwrap">
            <div className="custom-arrow-tabs">
              <Tabs
                activeKey={activeKey}
                className="custom-tabs"
                onChange={handleTabChange}
              >
                <TabPane
                  tab="01 Material Inward Note (MIN)"
                  key="1"
                  className="withtab"
                >
                  <AiDocIntakePdf
                    embedded
                    editDraftId={editDraftId}
                    onSaveAsDraft={() =>
                      goToTab(TAB_KEYS.DRAFTS, { clearEditDraft: true })
                    }
                    onConfirmReceipt={(info) =>
                      goToTab(
                        info?.documentType === "challan"
                          ? TAB_KEYS.GATE_LIST_CHALLAN
                          : TAB_KEYS.GATE_LIST_INVOICE,
                        { clearEditDraft: true },
                      )
                    }
                  />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      02 Drafts Goods Receipt
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={
                          <div style={{ color: "#fff", lineHeight: "1.6" }}>
                            <div>
                              1. Draft information saved from received document
                            </div>
                            <div>
                              2. Review & confirm physical document with scanned
                              draft
                            </div>
                            <div>3. Confirm materials received physically</div>
                          </div>
                        }
                      >
                        <InfoCircleOutlined
                          style={{ color: "white", marginLeft: "3px" }}
                        />
                      </Tooltip>
                    </span>
                  }
                  key="2"
                >
                  <DraftGoodsReceipt
                    embedded
                    refreshKey={refreshDrafts}
                    onAddReceipt={() =>
                      goToTab(TAB_KEYS.INTAKE, { clearEditDraft: true })
                    }
                    onEditDraft={(id) =>
                      goToTab(TAB_KEYS.INTAKE, { editDraftId: id })
                    }
                  />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      03 Goods Receipt List (Challan)
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={
                          <div style={{ color: "#fff", lineHeight: "1.6" }}>
                            <div>1. Material is received physically</div>
                            <div>
                              2. Quantity confirmation is sent to supplier for
                              this list
                            </div>
                            <div>
                              3. Quality confirmation & Distribution is pending
                            </div>
                            <div>4. Shows only challan-based receipts</div>
                          </div>
                        }
                      >
                        <InfoCircleOutlined
                          style={{ color: "white", marginLeft: "3px" }}
                        />
                      </Tooltip>
                    </span>
                  }
                  key="3"
                >
                  {acceptanceView ? (
                    <div>
                      <div className="ListingTopBar">
                        <div className="pagenamewrap">
                          <div className="pagename">
                            <h3>
                              {(acceptanceView.mode || "").toLowerCase() ===
                                "inspection" && "Material Inspection"}
                              {(acceptanceView.mode || "").toLowerCase() ===
                                "distribution" && "Material Distribution"}
                              {(acceptanceView.mode || "").toLowerCase() ===
                                "view" && "View Accepted & Distributed Material"}
                            </h3>
                            <div className="bredcrumbwrp">
                              <Link
                                onClick={() => setAcceptanceView(null)}
                                className="back"
                              >
                                <Back /> Back
                              </Link>
                              <Breadcrumb
                                className="Breadcrumb-Sec"
                                items={[
                                  {
                                    title: (
                                      <Link to="/dashboard">{t("home")}</Link>
                                    ),
                                  },
                                  {
                                    title: "Site Locations",
                                  },
                                ]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <AcceptanceDist
                        embedded
                        modeProp={acceptanceView.mode}
                        idProp={acceptanceView.id}
                        documentType={acceptanceView.documentType}
                        onBack={() => {
                          setAcceptanceView(null);
                          setRefreshGateListChallan((c) => c + 1);
                        }}
                      />
                    </div>
                  ) : (
                    <GoodsRecieptGateList
                      embedded
                      refreshKey={refreshGateListChallan}
                      documentType="challan"
                      onInspect={(mode, id) =>
                        setAcceptanceView({
                          mode,
                          id,
                          documentType: "challan",
                        })
                      }
                    />
                  )}
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      04 Goods Receipt List (Invoice)
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={
                          <div style={{ color: "#fff", lineHeight: "1.6" }}>
                            <div>1. Material is received physically</div>
                            <div>
                              2. Quantity confirmation is sent to supplier for
                              this list
                            </div>
                            <div>
                              3. Quality confirmation & Distribution is pending
                            </div>
                            <div>4. Shows only invoice-based receipts</div>
                          </div>
                        }
                      >
                        <InfoCircleOutlined
                          style={{ color: "white", marginLeft: "3px" }}
                        />
                      </Tooltip>
                    </span>
                  }
                  key="4"
                >
                  {acceptanceView ? (
                    <div>
                      <div className="ListingTopBar">
                        <div className="pagenamewrap">
                          <div className="pagename">
                            <h3>
                              {(acceptanceView.mode || "").toLowerCase() ===
                                "inspection" && "Material Inspection"}
                              {(acceptanceView.mode || "").toLowerCase() ===
                                "distribution" && "Material Distribution"}
                              {(acceptanceView.mode || "").toLowerCase() ===
                                "view" && "View Accepted & Distributed Material"}
                            </h3>
                            <div className="bredcrumbwrp">
                              <Link
                                onClick={() => setAcceptanceView(null)}
                                className="back"
                              >
                                <Back /> Back
                              </Link>
                              <Breadcrumb
                                className="Breadcrumb-Sec"
                                items={[
                                  {
                                    title: (
                                      <Link to="/dashboard">{t("home")}</Link>
                                    ),
                                  },
                                  {
                                    title: "Site Locations",
                                  },
                                ]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <AcceptanceDist
                        embedded
                        modeProp={acceptanceView.mode}
                        idProp={acceptanceView.id}
                        documentType={acceptanceView.documentType}
                        onBack={() => {
                          setAcceptanceView(null);
                          setRefreshGateListInvoice((c) => c + 1);
                        }}
                      />
                    </div>
                  ) : (
                    <GoodsRecieptGateList
                      embedded
                      refreshKey={refreshGateListInvoice}
                      documentType="invoice"
                      onInspect={(mode, id) =>
                        setAcceptanceView({
                          mode,
                          id,
                          documentType: "invoice",
                        })
                      }
                    />
                  )}
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      05 Site Receipt Conf.
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={
                          <div style={{ color: "#fff", lineHeight: "1.6" }}>
                            <div>
                              1. Quantity & Quality confirmation of received
                              material is completed
                            </div>
                            <div>
                              2. Distribution of confirmed material to
                              respective site is to be completed in this step
                            </div>
                          </div>
                        }
                      >
                        <InfoCircleOutlined
                          style={{ color: "white", marginLeft: "3px" }}
                        />
                      </Tooltip>
                    </span>
                  }
                  key="5"
                >
                  {physicalReceiptDocumentId ? (
                    <div>
                       <div className="ListingTopBar">
                        <div className="pagenamewrap">
                          <div className="pagename">
                            <h3>
                              {physicalReceiptIsViewMode
                                ? "View Site Inventory Confirmation"
                                : "Update Inventory"}
                            </h3>
                            <div className="bredcrumbwrp">
                              <Link
                                onClick={() => {
                                  setPhysicalReceiptDocumentId(null);
                                  setPhysicalReceiptSiteId(null);
                                  setPhysicalReceiptIsViewMode(false);
                                  setRefreshSiteReceipt((c) => c + 1);
                                }}
                                className="back"
                              >
                                <Back /> Back
                              </Link>
                              <Breadcrumb
                                className="Breadcrumb-Sec"
                                items={[
                                  {
                                    title: (
                                      <Link to="/dashboard">{t("home")}</Link>
                                    ),
                                  },
                                  {
                                    title: "Site Locations",
                                  },
                                ]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <StoreConfirmPhysicalReceipt
                        embedded
                        documentIdProp={physicalReceiptDocumentId}
                        siteIdProp={physicalReceiptSiteId}
                        onBack={() => {
                          setPhysicalReceiptDocumentId(null);
                          setPhysicalReceiptSiteId(null);
                          setPhysicalReceiptIsViewMode(false);
                          setRefreshSiteReceipt((c) => c + 1);
                        }}
                      />
                    </div>
                  ) : (
                    <InboundMaterialShipments
                      embedded
                      refreshKey={refreshSiteReceipt}
                      onConfirmPhysicalReceipt={(documentId, siteId, isFinalized) => {
                        setPhysicalReceiptDocumentId(documentId);
                        setPhysicalReceiptSiteId(siteId ?? null);
                        setPhysicalReceiptIsViewMode(!!isFinalized);
                      }}
                    />
                  )}
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TabwiseDocument;
